import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {history} from "../store/store";
import _ from "lodash";
import GobLogo from '../assets/images/gobmxlogo.svg';
import SecureLayout from "./secure";
import Notification from './../elements/notification';
import Navigation from "../elements/navigation/navigation";
import UserDropdown from "../elements/user-opts-dropdown";
import ProgressBar from "../cdm-frontend/elements/widgets/progress-bar";

export default function (SecuredComponent, data) {
	class CdmLayout extends Component {

		render() {
			const { notifications, location, session, menu } = this.props;
			const { municipality } = this.props.match.params;
			return [
				<Navigation agencies={{...session.user.agencies}} items={{...session.user.menu}} show={menu.view} location={{...location}} key={`app-navigation-sidebar`} />,

				<div className="main-content" key="main-website-content">
					<nav className="navbar is-dark secondary-navigation">
						<div className="navbar-menu navbar-item">
							<img src={GobLogo} alt="gob.mx" className="app-gov-logo--image" />
						</div>

						{session.user.version ?
							<div className="navbar-menu navbar-item">
								<h6 className="title is-6 has-text-centered has-text-white">{session.user.version.name}</h6>
							</div>:''}

						<button className="main-nav--close" onClick={() => this.toggleMenu()}>
							{menu.view ? <i className="fa fa-chevron-left" /> : <i className="fa fa-chevron-right" />}
						</button>
						<UserDropdown data={{...session.user.profile}} />
					</nav>

					{(data && data.subnav) &&
						<div className="subnavigation">
							<div className="level">
								<div className="level-item">
									<div className="subnav-section">
										<i className={`fa ${data.subnav.icon} has-text-cdm-dark-blue`} />
										<p>{data.subnav.name}</p>
									</div>
								</div>

								{data.subnav.actions &&
									_.map(data.subnav.actions, (slot, key) => {
										let item = this._subnavbarItem(slot);

										return <div className="level-item" key={`subnav-${key}`}>
											{item}
										</div>
									})
								}

                                {(data.progress) &&
                                    <div className="level-item">
                                        <ProgressBar total={70} detect={50} integrate={20} educate={10} followup={10} recognize={10} />
                                    </div>
                                }

								{(data.stateNav && data.stateNav === true) &&
									<div className="level-item subnav-states">
										<div className="field has-addons">
											<div className="control">
												<div className="select is-small is-dark">
													<select ref="stateNav-statesMun" value={this.state.showState} onChange={(field) => this.setState({showState: field.target.value})}>
														<option value="">--- Estado ---</option>
														{_.map(_.sortBy(session.user.agencies.states, ['name']), (st, key) => {
															return <option value={st.short} key={key}>{st.name}</option>
														})}
													</select>
												</div>
											</div>
											<div className="control">
												<div className="select is-small is-dark">
													<select ref="stateNav-muns" onChange={() => this._changeMuns()} value={municipality}>
														<option value="">--- Municipios ---</option>
														{_.map(_.uniqBy(_.sortBy(_.filter(session.user.agencies.municipalities, {modality_id: 3, state: {short: this.state.showState}}), ['name']),'id'), (mun, j) => {
															return <option value={mun.slug} key={j}>{mun.name}</option>
														})}
													</select>
												</div>
											</div>
										</div>
									</div>}

							</div>
						</div>}

					<section className="app-layout--content cdm">

						<h1 className="title is-1 main-title" dangerouslySetInnerHTML={{__html: data && data.title ? data.title : ''}}></h1>

						{notifications.active &&
						<div className="columns is-centered">
							<div className="column is-10-desktop">
								<Notification {...notifications} />
							</div>
						</div>}
						<div className="app-container">
							<SecuredComponent {...this.props} />
						</div>
						<div style={{height:'50px'}}>&nbsp;</div>
					</section>
				</div>
			]

		}

		constructor(props) {
			super(props);
			this.state = {
				profileShow: false,
				showState: props.match.params.state,
				dataFind: ''
			}
			this.toggleMenu = this.toggleMenu.bind(this);
		}

		_showProfile() {
			this.setState({
				profileShow: !this.state.profileShow
			});
		}

		_changeStates() {
			let state = this.refs['stateNav-states'].value;
			let url = _.split(history.location.pathname, '/', 5);
			if(url[4]==='administrativo' || url[4]==='juridica'){
				url[5] = state;
			}else {
				url[4] = state;
			}
			url = _.join(url, '/');
			history.push(url);
		}

		_changeMuns() {
			let mun = this.refs['stateNav-muns'].value;

			let url = _.split(history.location.pathname, '/', 6);
			if(url[4]==='administrativo' || url[4]==='juridica'){
				url[5] = this.state.showState;
				url[6] = mun;
			}else {
				url[4] = this.state.showState;
				url[5] = mun;
			}
			url = _.join(url, '/');
			history.push(url);
		}

		_changeDataFind(value){
			return this.setState({
				dataFind:value
			});
		}

		_keyPress(e,data){
			if(e.keyCode === 13){
				this._handleSearch(e.target.value,data);
			}
		}

		_handleSearch(value, data){
			if(value){
				switch (data){
					case 'municipalities':
						return this.props.findMunicipalities(value);
					case 'entities':
						return this.props.findEntities(value);
					case 'users':
						return this.props.findUsers(value);
					default:
						return console.log('find: ',value);
				}
			}
		}

		_subnavbarItem(item) {
			switch(item.type) {
				case 'button':
					return <div className="subnav-actions">
						<p>
							<NavLink to={item.url} className="button is-small is-inm-purple">{item.name}</NavLink>
						</p>
					</div>
				case 'search':
					return <div className="subnav-actions">
						{item.element}
					</div>
                case 'component':
                    return <div className="subnav-actions">
                        {item.element}
                    </div>
				default:
					return <div className="subnav-actions">
						<p>
							{item.name}
						</p>
					</div>
			}
		}

		toggleMenu() {
			let { view } = this.props.menu;
			return view === true ? this.props.hideMenu() : this.props.showMenu();
		}
	}

	return SecureLayout(CdmLayout);
}



// WEBPACK FOOTER //
// ./src/templates/cdm.jsx